import React, { Component } from 'react';
import '../css/getEditFormaPago.css';
import 'whatwg-fetch';
import { v4 as uuidv4 } from 'uuid';
import jsSHA from "jssha";

//import jquery from 'jquery';
//import  Payment  from  'https://cdn.paymentez.com/ccapi/sdk/payment_stable.min.js';
//import {loadScript} from "@pawjs/pawjs/src/utils/utils";

//import Cards from 'react-credit-cards';
//import 'react-credit-cards/es/styles-compiled.css'


class getInfoClient extends Component {
  constructor(){
    super();
    this.state = {
        forma_pago : [],
        tipo_forma_pago : [],
        accion :'',
        id_tarjeta_forma_pago:0,
        msg_loading :false,
        number: "",
        name: "",
        expiry: "",
        cvc: "",
        focus: "",
        sms:'',
        month:'',
        year:'',
        ENV_MODE : "stg",
        TEST_MODE : !0,
        PAYMENT_CLIENT_APP_CODE : "",
        PAYMENT_CLIENT_APP_KEY : "",
        IS_CHECKOUT : !1,
        MERCHANT_ID : 500005,
        KOUNT_ENVIRONMENT : "",
        KOUN_TEST_ENVIRONMENT:"https://tst.kaptcha.com/",
        KOUN_PROD_ENVIRONMENT : "https://ssl.kaptcha.com/",
        DOMAIN : "paymentez.com",
        SERVER_LOCAL_URL : "http://localhost:8000",
        SERVER_DEV_URL : 'https://ccapi-dev.paymentez.com',
        SERVER_STG_URL : 'https://ccapi-stg.paymentez.com',
        SERVER_QA_URL : 'https://ccapi-qa.paymentez.com',
        SERVER_PROD_URL : 'https://ccapi.paymentez.com',
        PG_MICROS_STAGING : 'https://pg-micros-stg.paymentez.com/v1/unixtime/',
        PG_MICROS_PRODUCTION : 'https://pg-micros.paymentez.com/v1/unixtime/',
        AUTH_TIMESTAMP_SERVER:String(new Date().getTime())
    }
  }
  // Payment.ENV_MODE = env_mode, Payment.PAYMENT_CLIENT_APP_CODE = payment_client_app_code, Payment.PAYMENT_CLIENT_APP_KEY = payment_client_app_key;
  getHash = (message)=> {
    let sha256 = new jsSHA("SHA-256", "TEXT");
    return sha256.update(message), sha256.getHash("HEX");
  }

  getUniqToken = (auth_timestamp, payment_client_app_key)=> {
    let uniq_token_string = payment_client_app_key + auth_timestamp;
    return this.getHash(uniq_token_string);
  }
  getAuthToken =  (payment_client_app_code, app_client_key)=> {
    let string_auth_token = payment_client_app_code + ";" + this.state.AUTH_TIMESTAMP_SERVER + ";" + this.getUniqToken( this.state.AUTH_TIMESTAMP_SERVER, app_client_key);
    return btoa(string_auth_token);
  }

  getServerURL = ()=> {
     let SERVER_URL = this.state.SERVER_STG_URL;
     return SERVER_URL = "" === this.state.ENV_MODE ? this.state.TEST_MODE ? this.state.SERVER_STG_URL
      : this.state.SERVER_PROD_URL : "dev" === this.state.ENV_MODE ? this.state.SERVER_DEV_URL : "stg"
       === this.state.ENV_MODE ? this.state.SERVER_STG_URL : "prod" === this.state.ENV_MODE ? this.state.SERVER_PROD_URL
       : "prod-qa" === this.state.ENV_MODE ? this.state.SERVER_QA_URL : this.state.SERVER_LOCAL_URL;
    }

  createToken = (createTokenRequest, successCallback, erroCallback)=> {
    //'stg', 'TPP3-EC-CLIENT', 'ZfapAKOk4QFXheRNvndVib9XU3szzg'
    console.log(createTokenRequest)
    let SERVER_URL = this.getServerURL()
    let xmlhttp = new XMLHttpRequest();
    xmlhttp.open("POST", SERVER_URL + "/v2/card/add", !0)
    xmlhttp.setRequestHeader("Content-Type", "application/json")
    xmlhttp.setRequestHeader("Auth-Token", this.getAuthToken('TPP3-EC-CLIENT',"ZfapAKOk4QFXheRNvndVib9XU3szzg"))
    xmlhttp.onreadystatechange = function (e) {
      if (xmlhttp.readyState === XMLHttpRequest.DONE)
        try {
          let objResponse = JSON.parse(xmlhttp.responseText);
          if(200 === xmlhttp.status) {
            successCallback(objResponse)
          }else{
             erroCallback(objResponse)
          }
        } catch (e) {
          erroCallback({
            error: {
              type: "Server Error",
              help: "Server Error",
              description: "Server Error"
          }
        });
      }
    }
    xmlhttp.send(JSON.stringify(createTokenRequest));

    /*
    var xhttp = new XMLHttpRequest();
    var self = this;

    xhttp.onreadystatechange = function(e){
      console.log(this);
      if (xhttp.readyState === 4 && xhttp.status === 200){
        console.log("ok, response :", this.response);
        self.setState({
          posts: JSON.parse(this.response)
        });
      }
    }
    xhttp.open("get", "https://jsonplaceholder.typicode.com/posts", true);
    xhttp.send();*/

}
  dataCollector = (session_id) =>{
    var  e, iframe, image;
    if ("" === this.state.ENV_MODE ? this.state.TEST_MODE ? this.state.KOUNT_ENVIRONMENT = this.state.KOUN_TEST_ENVIRONMENT :
    this.state.KOUNT_ENVIRONMENT = this.state.KOUN_PROD_ENVIRONMENT : "prod" === this.state.ENV_MODE ? this.state.KOUNT_ENVIRONMENT =
    this.state.KOUN_PROD_ENVIRONMENT : this.state.KOUNT_ENVIRONMENT = this.state.KOUN_TEST_ENVIRONMENT, "undefined" ==
    typeof document || void 0 === document.body || !document.body || "interactive" !== document.readyState && "complete" !== document.readyState)
     setTimeout(this, 150, session_id)
     else {

      iframe = document.createElement("iframe")
      iframe.setAttribute("id", "riskIframe")
      iframe.setAttribute("height", "1")
      iframe.setAttribute("scrolling", "no")
      iframe.setAttribute("frameborder", "0")
      iframe.setAttribute("width", "1")
      iframe.setAttribute("src", this.state.KOUNT_ENVIRONMENT + "logo.htm?m=" + this.state.MERCHANT_ID + "&s=" + session_id)
      image = document.createElement("img")
      image.setAttribute("height", "1")
      image.setAttribute("width", "1")
      image.setAttribute("src", this.state.KOUNT_ENVIRONMENT + "logo.gif?m=" + this.state.MERCHANT_ID + "&s=" + session_id)
      try {
        iframe.appendChild(image);
      } catch (_error) {
        e = _error;
      }
      document.getElementsByTagName("body")[0].appendChild(iframe)

    }
  }
 getSessionId = ()=> {
   let valor = uuidv4()
   //let valor2 =(""+valor).replace("-","")
   var res = valor.substr(0, 8)+valor.substr(9, 4)+valor.substr(14, 4)+valor.substr(19, 4)+valor.substr(24, 12);
   console.log(res)
   return res
 }
 addCard =(uid, email, card, success_callback, failure_callback)=> {
  let session_id = this.getSessionId();
  this.dataCollector(session_id);
  let params = {
    session_id: session_id,
    user: {
      id: uid,
      email: email
    }
  };
  params.card = card.card
  this.createToken(params, success_callback, failure_callback);
}

  handleInputFocus = (e) => {
    this.setState({ focus: e.target.name });
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;

    this.setState({ [name]: value });
  }

  getnewformapago =()=>{
    this.setState({
      accion :'newformapago'
    })
  }
  handleChanget = (event)=>{
    this.setState({
       id_tarjeta_forma_pago: event.target.value
    });
  }
  get_Forma_Pago_Cliente =()=>{
    const url= this.props.dir_url + "webapp/getFormasPagoClient";
    const token =  this.props.token
    const token_Client =  this.props.token_Client
    var obj = { accion:'formapagocliente', token, token_Client};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        this.setState({
          forma_pago : data[0].msg
        })
      }else{
        this.setState({
          forma_pago : []
        })
      }
    })
    .catch(console.log)
  }
  get_Forma_Pago_Tipo =()=>{
    const url= this.props.dir_url + "webapp/getFormasPagotipo";
    const token =  this.props.token
    const token_Client =  this.props.token_Client
    var obj = { accion:'formapagotipo', token, token_Client};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        this.setState({
          tipo_forma_pago : data[0].msg
        })
      }
    })
    .catch(console.log)
  }
  get_loading =(msg_loading)=>{
    this.setState({
      msg_loading
    })
  }

  getupdatedefaultFormaPago =(id_forma_pago)=>{
      //if(Number(id_forma_pago)>0){
        const url= this.props.dir_url + "webapp/getupdatedefaultFormaPago";
        const token =  this.props.token
        const token_Client =  this.props.token_Client
        var obj = { accion:'updatedefaultFormaPago', token, token_Client,id_forma_pago};
        fetch(url, {
          method: 'POST',
          body: JSON.stringify(obj),
          headers:{
            'Accept':'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(res => res.json())
        .then((data) => {
          if(data[0].status==="ok"){
            this.setState({
              id_tarjeta_forma_pago : 0
            },()=>{
              //this.get_Forma_Pago_Cliente()
              this.props.get_go_to_sub("")
            })

          }

        })
        .catch(console.log)
      //}
  }
  getdeletedefaultFormaPago =(id_forma_pago,por_defecto)=>{

      const url= this.props.dir_url + "webapp/getdeletedefaultFormaPago";
      const token =  this.props.token
      const token_Client =  this.props.token_Client
      var obj = { accion:'deletedefaultFormaPago', token, token_Client,id_forma_pago,por_defecto};
      fetch(url, {
        method: 'POST',
        body: JSON.stringify(obj),
        headers:{
          'Accept':'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then(res => res.json())
      .then((data) => {
        //if(data[0].status==="ok"){
          this.get_Forma_Pago_Cliente()
        //}
      })
      .catch(console.log)
  }
  getaddCard =()=>{
    //7console.log("ss")

    this.getsaveformapago();
  /*  if(1==1){

     this.addCard(uid, email, cardToSave, this.successHandler, this.errorHandler)
   }*/

  }
  successHandler = (cardResponse)=> {

    /*    this.get_loading(false)
       if (cardResponse.card.status === 'valid') {
        /*$('#messages').html('Card Successfully Added<br>' +
          'status: ' + cardResponse.card.status + '<br>' +
          "Card Token: " + cardResponse.card.token + "<br>" +
          "transaction_reference: " + cardResponse.card.transaction_reference
        );
        this.getsaveformapago(cardResponse.card.transaction_reference,cardResponse.card.token,cardResponse.card.number)
      } else if (cardResponse.card.status === 'review') {
        /*$('#messages').html('Card Under Review<br>' +
          'status: ' + cardResponse.card.status + '<br>' +
          "Card Token: " + cardResponse.card.token + "<br>" +
          "transaction_reference: " + cardResponse.card.transaction_reference
        );
      } else {
        /*$('#messages').html('Error<br>' +
          'status: ' + cardResponse.card.status + '<br>' +
          "message Token: " + cardResponse.card.message + "<br>"
        );
      }*/

    }

  errorHandler = (err)=> {
    this.get_loading(false)
    this.setState({
      sms : err.error.description
    })
  };
  getsaveformapago =(referencia,token_tarjeta,number)=>{
    const id_tarjeta_forma_pago = this.state.id_tarjeta_forma_pago
    if(Number(id_tarjeta_forma_pago)!==0){
      const url= this.props.dir_url + "webapp/getsaveformapago";
      const token =  this.props.token
      const token_Client =  this.props.token_Client
      var obj = { accion:'saveformapago', token, token_Client,id_tarjeta_forma_pago,referencia,token_tarjeta,number};
      fetch(url, {
        method: 'POST',
        body: JSON.stringify(obj),
        headers:{
          'Accept':'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then(res => res.json())
      .then((data) => {
        if(data[0].status==="ok"){
          this.setState({
            accion :''
          },()=>{
            //this.get_Forma_Pago_Cliente()
            this.props.get_go_to_sub("")
          })
          //this.get_loading(false)
        }
      })
      .catch(console.log)
      this.get_loading(true)

    }

  }
  getllenarFormaPagos =()=>{
    const forma_pago = this.state.forma_pago
    let id_forma_pago = 0
    if(forma_pago){
      forma_pago.map(pago => (
        id_forma_pago = Number(pago.por_defecto)
      ))
    }
    return (
      <React.Fragment>
      <div className="grid-container-menu_list_formapago_izq" onClick={ () => this.getupdatedefaultFormaPago(0)}>
        <div className="div_menu_1_list_formapago_izq">
          <span style={{"color":"black"}}>Efectivo</span>
        </div>
        <div className="lbl_menu_2_list_formapago_izq">
          {(id_forma_pago===0)?
          <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/7774226221582004489-128.png') } />
          :''}
        </div>
      </div>
      {forma_pago.map(pago => (
        <div key={pago.id_forma_pago} className="grid-container-menu_list_formapago_der" >
          <div className="div_menu_1_list_formapago_der"  onClick={ () => this.getdeletedefaultFormaPago(pago.id_forma_pago,pago.por_defecto)}>
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/14458160321582004493-128.png') } />
          </div>
          <div className="lbl_menu_2_list_formapago_der" onClick={ () => this.getupdatedefaultFormaPago(pago.id_forma_pago)}>
            Tarjeta {pago.tarjeta}
          </div>
          <div className="lbl_menu_3_list_formapago_der" onClick={ () => this.getupdatedefaultFormaPago(pago.id_forma_pago)}>
            {(Number(pago.id_forma_pago)===Number(pago.por_defecto))?
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/7774226221582004489-128.png') } />
            :''
          }
          </div>
        </div>
      )) }
      </React.Fragment>
    )
  }
/*<div className="card">
      <div className="card-body">
        <form>
          <div>
            <input
                type="text"
                name="number"
                id="number"
                maxLength="16"
                className="input-card"
                onChange={this.handleInputChange}
                onFocus={this.handleFocusChange}
                placeholder="Número de la tarjeta"
            />
            <input
                type="text"
                name="name"
                id="name"
                maxLength="30"
                className="input-card"
                onChange={this.handleInputChange}
                onFocus={this.handleFocusChange}
                placeholder="Nombre"
            />
                <input
                    type="text"
                    name="expiry"
                    id="expiry"
                    maxLength="4"
                    className="input-card"
                    onChange={this.handleInputChange}
                    onFocus={this.handleFocusChange}
                    placeholder="Fecha de expiración MMAA"
                />
                <input
                    type="text"
                    name="cvc"
                    id="cvc"
                    maxLength="4"
                    className="input-card"
                    onChange={this.handleInputChange}
                    onFocus={this.handleFocusChange}
                      placeholder="CVC"
                />
              </div>
          </form>
      </div>
      <div className="grid-container-menu_list_formapago_izq">
        <div className="div_menu_1_list_formapago_izq">
            <select className="select-css_global" value={this.state.id_tarjeta_forma_pago} onChange={(e) => {this.handleChanget(e)}}>
            <option value="0">Seleccione Tipo de Tarjeta</option>
            {(tipo_forma_pago.length !== 0) ?
              tipo_forma_pago.map(tarjeta => (
                <option key={tarjeta.id_tarjeta} value={tarjeta.id_tarjeta} >{tarjeta.tarjeta}</option>
              ))
              : <React.Fragment></React.Fragment>
            }
          </select>
        </div>
        <div className="lbl_menu_2_list_formapago_izq" onClick={ () => this.getsaveformapago()}>
          <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12817025351582004496-128.png') } />
        </div>
      </div>
      <Cards
        cvc={this.state.cvc}
        expiry={this.state.expiry}
        focused={this.state.focus}
        name={this.state.name}
        number={this.state.number}
      />
    </div>>*/
  getListaFichaNuevoPago =()=>{

    const tipo_forma_pago = this.state.tipo_forma_pago
    return (
      <div className="panel">
        <div className="grid-container-menu_list_formapago_izq">
          <div className="div_menu_1_list_formapago_izq">
              <select className="select-css_global" value={this.state.id_tarjeta_forma_pago} onChange={(e) => {this.handleChanget(e)}}>
              <option value="0">Seleccione Tipo de Tarjeta</option>
              {(tipo_forma_pago.length !== 0) ?
                tipo_forma_pago.map(tarjeta => (
                  <option key={tarjeta.id_tarjeta} value={tarjeta.id_tarjeta} >{tarjeta.tarjeta}</option>
                ))
                : <React.Fragment></React.Fragment>
              }
            </select>
          </div>
          <div className="lbl_menu_2_list_formapago_izq" onClick={ () => this.getaddCard()}>
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12817025351582004496-128.png') } />
          </div>
        </div>
        <div id="messages"><span style={{"color":"red"}}>{this.state.sms}</span></div>
      </div>

    )
  }
  render() {
    let ficha_nueva_forma_pago
    const accion = this.state.accion
    if(accion==="newformapago"){
      ficha_nueva_forma_pago =  <React.Fragment>{this.getListaFichaNuevoPago()}</React.Fragment>
    }
    let modal_loading
    const msg_loading = this.state.msg_loading
    if(msg_loading){
      modal_loading = <div id="loader" className="loader loader-default is-active" data-text=""></div>
    }
    return (
      <div className="modal-dialog-forma_pago">
        <div className="modal-content-forma_pago">
          <div className="grid-container-menu_list_formapago">
            <div className="div_menu_1_list_formapago">
              <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128.png') } onClick={ () => this.props.get_go_to_sub("")} />
            </div>
            <div className="lbl_menu_2_list_formapago">
              <span className="span-global-link">Elija Forma de Pago</span>
            </div>
          </div>
          {this.getllenarFormaPagos()}
          <div className="grid-container-menu_list_formapago_izq"  onClick={ () => this.getnewformapago()}>
            <div className="div_menu_1_list_formapago_izq">
              Añadir Tarjeta
            </div>
            <div className="lbl_menu_2_list_formapago_izq">
              <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12817025351582004496-128.png') } />
            </div>
          </div>
          {ficha_nueva_forma_pago}
        </div>
        {modal_loading}
      </div>
    );
  }

  componentDidMount (){
    this.get_Forma_Pago_Cliente();
    this.get_Forma_Pago_Tipo();
  }
}
export default getInfoClient;
